import(/* webpackMode: "eager" */ "/app/app/components/BlockCards/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/BottomWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/ComingSoon/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/ContactUs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/CookiesConsent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FlowSchemeStatic"] */ "/app/app/components/FlowSchemeStatic/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/app/app/components/HeroSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MiddleWrapper"] */ "/app/app/components/MiddleWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/SelectionProcess/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/SystematicStrategies/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/SystematiPreselection/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/Team/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopRef"] */ "/app/app/components/TopRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyModal"] */ "/app/app/features/privacyPolicy/privacyPolicyModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/app/shared/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/shared/ParallaxWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/app/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
